import React from "react";
import { domainTheme, type DomainCode } from "@/lib/domainTheme";

export function DomainPill({ code }: { code?: string }) {
  if (!code || !(code in domainTheme)) {
    return (
      <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset bg-slate-100 text-slate-700 ring-slate-200">
        {code ?? "—"}
      </span>
    );
  }

  const { pill } = domainTheme[code as DomainCode];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${pill}`}>
      {code}
    </span>
  );
}